import { render, staticRenderFns } from "./PropertyCaseCard.vue?vue&type=template&id=74794c92"
import script from "./PropertyCaseCard.vue?vue&type=script&lang=js"
export * from "./PropertyCaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports